import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthContextService } from '@core/services/auth-context.service';
import { AuthService } from '@core/services/auth.service';

@Component({
  selector: 'app-callback-signin',
  standalone: true,
  templateUrl: './callback-signin.component.html',
  styleUrl: './callback-signin.component.scss',
})
export class CallbackSigninComponent implements OnInit {
  private readonly ctx = inject(AuthContextService);
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  async ngOnInit(): Promise<void> {
    const mode = this.ctx.getMode();
    this.auth.setActivePoolsMode(mode);

    await this.auth.ensureUserPoolsLoaded(mode);

    const session = await this.auth.safeFetchAuthSession?.();
    const logged = !!session?.tokens?.idToken;

    if (!logged) {
      this.ctx.clearPostLoginTarget();
      this.router.navigateByUrl(
        mode === 'upload-files' ? '/upload-files' : '/login',
      );
      return;
    }

    const ok = await this.auth.refreshUserToken(false, true, true);
    if (!ok) {
      await this.auth.refreshUserToken(true, false, true);
    }

    this.auth.setAuthenticated(true);

    const target = this.ctx.getPostLoginTarget();
    this.ctx.clearPostLoginTarget();

    this.router.navigateByUrl(target);
  }
}
